import { LoaderCircle, Search, X } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import api, { getError } from "@/api";

export const CatalogueImageSearch = ({ onResults }) => {
  const [file, setFile] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const runSearch = async (event) => {
    event.preventDefault();

    if (!file) {
      toast.error("Choisissez une photo de produit à analyser.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    setIsSearching(true);

    try {
      const response = await api.post("/catalogue/image-search", formData);
      onResults(response.data);
      toast.success("La recherche visuelle est terminée.");
    } catch (error) {
      toast.error(getError(error));
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <form
      className="catalogue-image-search"
      data-testid="catalogue-image-search-form"
      onSubmit={runSearch}
    >
      <div>
        <p className="eyebrow">RECHERCHE VISUELLE</p>
        <strong>Retrouvez un produit à partir de sa photo</strong>
        <span>JPG, PNG ou WEBP · 5 Mo maximum</span>
      </div>
      <div className="catalogue-image-search-actions">
        <label className="catalogue-image-file" data-testid="catalogue-image-upload-label">
          <span>{file?.name || "Choisir une photo"}</span>
          <input
            accept="image/jpeg,image/png,image/webp"
            data-testid="catalogue-image-upload-input"
            onChange={(event) => setFile(event.target.files?.[0] || null)}
            type="file"
          />
        </label>
        <button
          className="primary-action"
          data-testid="catalogue-image-search-submit-button"
          disabled={isSearching}
          type="submit"
        >
          {isSearching ? <LoaderCircle className="dashboard-spinner" size={17} /> : <Search size={17} />}
          {isSearching ? "Analyse…" : "Rechercher"}
        </button>
      </div>
      {file && (
        <button
          className="catalogue-image-clear-file"
          data-testid="catalogue-image-clear-file-button"
          onClick={() => setFile(null)}
          type="button"
        >
          <X size={15} /> Retirer la photo
        </button>
      )}
    </form>
  );
};